// 模块数据折线图
import React, {
  Component,
} from "react";
import moment from "moment";
import Echarts from "echarts";
// 国际化切换语言
import { injectIntl } from "react-intl";
import { powermoduleHis } from "../../../fetch/fetchApi";
import "../../../assets/stylus/com/display/process.styl";

class PowerMoudleChargeCourse extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.powerMoudleChargeCourse;
    this.init();
    this.state = {
      currentPhase: "stub",
      showNodata: false,
    };
    console.log(this.context);
  }

  /**
   * 页面进入调用方法，获取tab间传递数据
  */
  init() {
    this.query = {
      page: "1",
      pagecount: "10",
    };

    /**
       * moduleChartType = 1 ->从订单页面进入模块数据页面，通过orderId（订单编号）获取模块数据
       * moduleChartType = 2 ->从事件告警、设备快速查询，进入模块数据页面，通过startTime、endTime、stubId（设备编号） 查询并获取模块数据
      */
    if (this.props.moduleChartType === "1") {
      this.query["id"] = this.props.params["orderId"];
    } else if (this.props.moduleChartType === "2") {
      this.query["startTime"] = this.props.searchDate[0];
      this.query["endTime"] = this.props.searchDate[1];
      this.query["id"] = this.props.stubId;
    }
    console.log(this.query);
  }

  componentDidUpdate(prevProps) {
    console.log("changeProps--------------------------------------------------");
    console.log(this.props);
    console.log(prevProps);
    if (this.props.moduleChartType === "2") {
      console.log("initProps--------------------------------------------------");
      console.log(prevProps.stubId !== this.props.stubId
        || prevProps.searchDate[0] !== this.props.searchDate[0]
        || prevProps.searchDate[1] !== this.props.searchDate[1]);

      if (prevProps.stubId !== this.props.stubId
        || prevProps.searchDate[0] !== this.props.searchDate[0]
        || prevProps.searchDate[1] !== this.props.searchDate[1]) {
        console.log("initProps--------------------------------------------------");

        this.query["startTime"] = this.props.searchDate[0];
        this.query["endTime"] = this.props.searchDate[1];
        this.query["id"] = this.props.stubId;
        this.queryChargeInfo();
      }
    }
  }

  componentDidMount() {
    if (window.LayoutTab) {
      setTimeout(() => {
        this.init();
        this.queryChargeInfo();
      }, 1);
    }
  }

  /**
   * 查询模块数据接口，通过moduleChartType判断类型
  */
  queryChargeInfo() {
    if (this.props.moduleChartType === "1") {
      this.getPowerModule(this.query["id"]).then((data) => {
        console.log("--------------------------------------------订单详情充电过程");
        this.initChart(data);
      });
    } else if (this.props.moduleChartType === "2") {
      this.getPowerModuleByStub(this.query["id"], this.query["startTime"], this.query["endTime"]).then((data) => {
        console.log(data.data);
        this.initChart(data);
      });
    }
  }

  /**
   * 通过订单编号获取模块数据
  */
  async getPowerModule(id) {
    try {
      const resData = await powermoduleHis({
        orderId: id,
      });
      this.setState({
        arryList: resData.data.data,
      });
      return resData.data;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 通过起止事件、设备编号获取模块数据
  */
  async getPowerModuleByStub(id, st, et) {
    try {
      const resData = await powermoduleHis({
        stubId: id,
        startTime: st,
        endTime: et,
      });
      this.setState({
        arryList: resData.data.data,
      });
      console.log(resData.data);
      return resData.data;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 判断模块品牌并返回
  */
  changeBrand(sn) {
    if (sn.slice(0, 4) === "2300") {
      return this.internationalization.brand1;// '台达';
    } else if (sn.slice(0, 2) === "19") {
      return this.internationalization.brand2;// '星星';
    } else if (sn.slice(0, 6) === "291002") {
      return this.internationalization.brand3;
    }
    return "";
  }

  // 图表展示
  initChart() {
    const {
      arryList,
    } = this.state;
    const moduleInfo = [];

    // 格式化数据，在每个订单后增加一条空数据
    arryList.map((item) => {
      const kong = [""];
      const kong2 = {};
      item[1].map((item2) => {
        Object.keys(item2[1]).forEach((s) => {
          item2[1][s].push(item[0]);
          kong2[s] = [
            "",
            "",
            "", [], "", "",
          ];
        });
        moduleInfo.push(item2);
        return null;
      });

      kong.push(kong2);
      moduleInfo.push(kong);
      return null;
    });

    const snList = []; // sn列表
    if (moduleInfo && moduleInfo[0] && moduleInfo[0][1]) {
      Object.keys(moduleInfo[0][1]).forEach((key) => {
        snList.push(key);
      });
    }

    const xAxisData = []; // x轴
    if (moduleInfo) {
      moduleInfo.forEach((item) => {
        if (item[0]) {
          xAxisData.push(moment(item[0]).format("YYYY-MM-DD HH:mm:ss"));
        } else {
          xAxisData.push("");
        }
      });
    }

    // 判断是否存在数据，若存在则继续执行，否则展示暂无数据样式，并且返回方法
    if (xAxisData.length === 0) {
      this.setState({
        showNodata: true,
      });
      return;
    } else {
      this.setState({
        showNodata: false,
      });
    }
    // 去除x轴末尾空数据
    xAxisData.pop();
    const chartIds = ["chartv", "charta", "chartc", "chartsub"];
    const option = {
      tooltip: {
        trigger: "axis",
        formatter: (params) => {
          if (params[0].value) {
            let result = "";
            result += `<div style="font-size:0.2px;width:400px">${this.internationalization.wz1}：${params[0].data.orderId} </div>`;
            result += `<div style="font-size:0.2px;width:400px">${params[0].axisValue}，环境温度${params[0].data.environmentTemp}℃</div>`;
            params.map((item, index) => {
              const data = item.data;
              const num = params.length - 1;
              if (index < num / 4) {
                let messageInfo = null;
                if (item.axisIndex === 0) {
                  messageInfo = `
                                  ${this.internationalization.msg1}:${params[index].data.value ? params[index].data.value : "--"}V,
                                  ${this.internationalization.msg2}:${params[index + num / 4].data.value ? params[index + num / 4].data.value : "--"}A,
                                  ${this.internationalization.msg3}:${params[index + 2 * (num / 4)].data.value ? params[index + 2 * (num / 4)].data.value : "--"}℃,
                                  差值:${params[index + (3 * (num / 4) + 1)].data.value ? params[index + (3 * (num / 4) + 1)].data.value : "--"}℃,
                                    `;
                } else if (item.axisIndex === 1) {
                  messageInfo = `
                                    ${this.internationalization.msg1}:${params[index + num / 4].data.value ? params[index + num / 4].data.value : "--"}V,
                                    ${this.internationalization.msg2}:${params[index].data.value ? params[index].data.value : "--"}A,
                                    ${this.internationalization.msg3}:${params[index + 2 * (num / 4)].data.value ? params[index + 2 * (num / 4)].data.value : "--"}℃,
                                    差值:${params[index + (3 * (num / 4) + 1)].data.value ? params[index + (3 * (num / 4) + 1)].data.value : "--"}℃,
                                      `;
                } else if (item.axisIndex === 2) {
                  messageInfo = `
                                    ${this.internationalization.msg1}:${params[index + (num / 4 + 1)].data.value ? params[index + (num / 4 + 1)].data.value : "--"}V,
                                    ${this.internationalization.msg2}:${params[index + (2 * (num / 4) + 1)].data.value ? params[index + (2 * (num / 4) + 1)].data.value : "--"}A,
                                    ${this.internationalization.msg3}:${params[index].data.value ? params[index].data.value : "--"}℃,
                                    差值:${params[index + (3 * (num / 4) + 1)].data.value ? params[index + (3 * (num / 4) + 1)].data.value : "--"}℃,
                                      `;
                } else if (item.axisIndex === 3) {
                  messageInfo = `
                                  ${this.internationalization.msg1}:${params[index + num / 4].data.value ? params[index + num / 4].data.value : "--"}V,
                                  ${this.internationalization.msg2}:${params[index + 2 * (num / 4)].data.value ? params[index + 2 * (num / 4)].data.value : "--"}A,
                                  ${this.internationalization.msg3}:${params[index + 3 * (num / 4)].data.value ? params[index + 3 * (num / 4)].data.value : "--"}℃,
                                  差值:${params[index].data.value ? params[index].data.value : "--"}℃,
                                    `;
                }
                result += `<div style="font-size:0.2px;width:400px">
                      <div>${item.marker}SN:${item.seriesName}${this.changeBrand(item.seriesName)}</div>
                      <div>${messageInfo}</div>                           
                      <div style="white-space:normal;word-break:break-all">${this.internationalization.title1}:${data.info !== "" ? data.info : "--"}</div>
                     </div>`;
              }
              return true;
            });
            return result;
          }
        },
        position: (point, params, dom, rect, size) => { // point: 鼠标位置
          let x = "";
          if (point[0] < (size.viewSize[0] / 2)) {
            x = point[0];
          } else {
            x = point[0] - 250;
          }

          return [x, "5%"];
        },
      },
      legend: {
        data: snList.map((item) => {
          return {
            name: item,
          };
        }),
      },
      axisPointer: {
        link: {
          xAxisIndex: "all",
        },
      },
      grid: [{
        x: "8%",
        y: "10%",
        height: "14%",
      }, {
        x: "8%",
        y: "32%",
        height: "14%",
      }, {
        x: "8%",
        y: "56%",
        height: "14%",
      }, {
        x: "8%",
        y: "80%",
        height: "14%",
      }],
      xAxis: [{
        type: "category",
        data: xAxisData,
        gridIndex: 0,
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 10,
          formatter: (value) => {
            if (value) {
              const text = value.split(" ");
              return `${text[0]}\n${text[1]}`;
            } else {
              return value;
            }
          },
        },
      }, {
        type: "category",
        data: xAxisData,
        gridIndex: 1,
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 10,
          formatter: (value) => {
            if (value) {
              const text = value.split(" ");
              return `${text[0]}\n${text[1]}`;
            } else {
              return value;
            }
          },
        },
      }, {
        type: "category",
        data: xAxisData,
        gridIndex: 2,
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 10,
          formatter: (value) => {
            if (value) {
              const text = value.split(" ");
              return `${text[0]}\n${text[1]}`;
            } else {
              return value;
            }
          },
        },
      }, {
        type: "category",
        data: xAxisData,
        gridIndex: 3,
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 10,
          formatter: (value) => {
            if (value) {
              const text = value.split(" ");
              return `${text[0]}\n${text[1]}`;
            } else {
              return value;
            }
          },
        },
      }],
      yAxis: [{
        type: "value",
        name: `${this.internationalization.msg1}（V）`,
        gridIndex: 0,
      }, {
        type: "value",
        name: `${this.internationalization.msg2}（A）`,
        gridIndex: 1,
      }, {
        type: "value",
        name: `${this.internationalization.msg3}（℃）`,
        gridIndex: 2,
      }, {
        type: "value",
        name: "温差（℃）",
        gridIndex: 3,
      }],

    };
    option.series = [];
    let axisIndx = 0;
    const environmentTempL = [];
    Object.keys(chartIds).forEach((id) => {
      const valueL = [];
      // let seriesDataArr = [];
      if (moduleInfo) {
        moduleInfo.map((data) => {
          if (data[1]) {
            Object.keys(data[1]).forEach((key) => {
              let valueItem;
              if (id === '3') {
                valueItem = (data[1][key].length === 7 ? data[1][key][5] : null);
              } else {
                valueItem = data[1][key][id];
              }
              valueL.push({
                id: key,
                value: valueItem,
                info: data[1][key][3].join(","),
                orderId: data[1][key].length === 7 ? data[1][key][6] : data[1][key][4],
                environmentTemp: data[1][key].length === 7 ? data[1][key][4] : "--",
              });
            });
          }
          return null;
        });
      }
      //  模块名称转换
      if (snList) {
        snList.map((sn) => {
          option.series.push({
            name: sn,
            type: "line",
            data: valueL.filter((item) => {
              return item.id === sn;
            }),
            xAxisIndex: axisIndx,
            yAxisIndex: axisIndx,
          });
          return null;
        });
      }
      axisIndx++;
    });
    option.series[0].data.map((item) => {
      environmentTempL.push(item.environmentTemp);
      return null;
    });

    // 设置环境温度
    option.series.push({
      name: "环境温度",
      type: "line",
      data: environmentTempL,
      symbol: "none",
      lineStyle: {
        type: "dashed",
        color: "rgba(255,215,0,.8)",
      },
      xAxisIndex: 2,
      yAxisIndex: 2,
    });

    if (xAxisData.length > 30) {
      const dataZoom = [{
        type: "inside",
        startValue: 0,
        endValue: 30,
        // maxValueSpan:30,
        xAxisIndex: [0, 1, 2, 3],
        showDetail: false,
      }, {
        showDetail: false,
        startValue: 0,
        endValue: 30,
        handleIcon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        handleSize: "40%",
        handleStyle: {
          color: "#fff",
          shadowBlur: 3,
          shadowColor: "rgba(0, 0, 0, 0.6)",
          shadowOffsetX: 2,
          shadowOffsetY: 2,
        },
        xAxisIndex: [0, 1, 2, 3],
      }];

      option["dataZoom"] = dataZoom;
    }

    /**
       * 去除每条data后的空数据
       */
    option.series.map((item) => {
      item.data.pop();
      return null;
    });

    const myChart = Echarts.init(document.getElementById(`chart${this.query.id}`));
    myChart.clear();
    myChart.setOption(option);
    console.log(option);
    myChart.on("legendselectchanged", (obj) => {
      if (obj.name) {
        const sn = obj.name;
        this.setState({
          sn: sn,
          snTxt: obj.name + this.changeBrand(obj.name),
          snDetailListVisible: true,
        });
      }
    });

    myChart.on("click", (value) => {
      console.log(value);
      console.log(myChart.option);
    });
  }

  /**
   * 时分秒格式转换
  */
  translateTime= (e) => {
    const time = e;
    const newTime = new Date(parseInt(time));
    const hours = newTime.getHours() < 10 ? `0${newTime.getHours()}` : newTime.getHours();
    const minutes = newTime.getMinutes() < 10 ? `0${newTime.getMinutes()}` : newTime.getMinutes();
    const seconds = newTime.getSeconds() < 10 ? `0${newTime.getSeconds()}` : newTime.getSeconds();
    return `${hours}:${minutes}:${seconds}`;
  }

  render() {
    const powerData = (
      <div style={{ padding: "20px 20px 20px 20px" }}>
        {this.props.subjectSerial
          ? <div>{this.internationalization.title1}:{this.props.subjectSerial}</div> : null}
        {this.state.showNodata ? <div className="kongMsg">{this.internationalization.wz3}</div>
          : (
            <div className='moduleBox'>
              <div className="g2item1">
                <div id={`chart${this.query.id}`} className="g2container1"></div>
              </div>
            </div>)}
      </div>);

    return powerData;
  }
}

export default injectIntl(PowerMoudleChargeCourse);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/powerMoudleChargeCourse.js